import { useFetch, useIsLoading } from "../../Hooks/useFetch";
import EntitySection from "../../Components/Shared/EntitySection/EntitySection";
import {
  currencyColumn,
  expirationColumn,
  idColumn,
  nameColumn,
  textColumn,
  yesNoColumn,
} from "../../Components/Shared/TableColumns/tableColumns";
import { getAllDomains, deleteDomains } from "../../Service/InventoryService/InventoryService";
import DomainDetail from "./DomainDetail";
import { distinctFilter, expirationFilter, yesNoFilter } from "../../Components/Shared/TableFilters/filterDefs";

export const Domains = () => {
  const [domains, isFetchingDomains, updateDomains] = useFetch(getAllDomains);
  const isLoading = useIsLoading([isFetchingDomains]);

  const columns = [
    idColumn(),
    nameColumn("url", "URL"),
    expirationColumn(),
    textColumn("hosting", "Hosting"),
    currencyColumn("cost_re", "Coste"),
    yesNoColumn("auto_re", "Autorenovación"),
  ];

  const filters = [
    distinctFilter("hosting", "Hosting", domains, "hosting"),
    yesNoFilter("auto_re", "Autorenovación", "auto_re"),
    expirationFilter(),
  ];

  return (
    <EntitySection
      filters={filters}
      title="Dominios"
      addLabel="Añadir dominio"
      type="dominio"
      rows={domains}
      loading={isLoading}
      columns={columns}
      onDelete={(row) => deleteDomains(row.id)}
      onChanged={updateDomains}
      detailTitle="Información del Dominio"
      renderDetail={(row) => <DomainDetail row={row} />}
    />
  );
};
